const global_config = {
  //root_url: 'https://lca.ssbti.org',
  root_url: 'https://photo-x.space/server',
  // root_url: 'http://localhost:8080',
}


export default global_config